<template>
    <form-row title="Have you prepared sellers documents?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_prepared_sellers_documents"
                v-model="has_prepared_sellers_documents"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_prepared_sellers_documents"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Prepared:"
                :value="attorney.prepared_sellers_documents_at"
                name="prepared_sellers_documents_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_prepared_sellers_documents: this.attorney.has_prepared_sellers_documents,
        }
    },
}
</script>
